import { App as Campus } from './SpaceCollections/Campus/appDeclaration';
import { App as PortfolioInsights } from './PortfolioInsights/appDeclaration';

export const Apps = {
    [Campus.schema]: Campus,
    [PortfolioInsights.schema]: PortfolioInsights,
}
